module.exports = __webpack_public_path__ + "img/white-back-Logo.316bd98e.png";